import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  id: "legend",
  class: "legend"
}
const _hoisted_3 = { class: "legendItems" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("canvas", {
      id: $props.id,
      ref: "lineCanvas",
      style: _normalizeStyle([{"height":"100%","width":"100%"}, $props.styleLineChart])
    }, null, 12, _hoisted_1),
    (
      _ctx.$route.name === 'CustomersSatisfactionReport' &&
      $props.id === 'lineChartTwoLegends'
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (el, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "item"
              }, [
                _createElementVNode("img", {
                  class: "item-img",
                  src: require(`@/assets/icons/${el.label}.png`),
                  alt: ""
                }, null, 8, _hoisted_4)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}